import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/auth';

function AdminRoute({ children }) {
  var { isAuthenticated, authTokens } = useAuth();
  var location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/signup" state={{ referer: location }} replace />;
  }

  if (!authTokens?.user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminRoute;
